import React, { useState } from "react";
import { postAPI } from '../app/api';
import Swal from 'sweetalert2';
import { setStore, removeStore, store } from '../app/store';

const RazorpayCheckout = ({ handleSubmit, Loading, module, Amount, Value }) => {
  // const [loading, setLoading] = useState(false);
  // console.log({ module, Amount, Value })

  return (
    <button
       type="button" className="submit-btn"
      onClick={handleSubmit}
      disabled={Loading}
    >
      <span><i className="bx bx-x"></i></span>
      {Loading ? 'Loading...' : 'Pay Now'}
    </button>
  );
};

export default RazorpayCheckout;
